import moment from 'moment';
import mediaQuery from './../../mixins/mediaQuery';

export default {
  props: {
    day: {
      required: true,
      type: Object,
    },

    displayWeekends: {
      required: true,
      type: Boolean,
    },

    changeDay: {
      required: true,
      type: Function,
    },

    toggleWeekends: {
      required: true,
      type: Function,
    },
  },

  computed: {
    finalDay() {
      const n = this.displayWeekends ? 6 : 4;
      return moment(this.initialDay()).add(n, 'days');
    },
  },

  methods: {
    daysToSkip() {
      if (!this.$refs.days) return 1;

      return !this.isDesktop() ? 1 : 7;
    },

    initialDay() {
      return moment(this.day);
    },
  },

  mixins: [
    mediaQuery,
  ],
};



// WEBPACK FOOTER //
// ./src/app/components/dateBar/dateBar.js